import type { ExperimentState } from "../types";

type Props = {
  state: ExperimentState;
  saveStatus: "saved" | "saving" | "local" | "error";
  onStop: () => void;
};

const statusText = {
  saved: "保存済み",
  saving: "保存中…",
  local: "端末に保存済み",
  error: "再送待ち",
};

export function SiteHeader({ state, saveStatus, onStop }: Props) {
  const activeExperiment = !["pre-questionnaire", "complete"].includes(state.stage);
  const condition = state.sequence[Math.min(state.blockNumber, 2)];

  return (
    <header className="site-header">
      <a className="brand" href="/" aria-label="人物相関図 本実験テストサイト">
        <span className="brand-mark">R</span>
        <span>
          <strong>RELATION STUDY</strong>
          <small>人物相関図・本実験プロトタイプ</small>
        </span>
      </a>
      <div className="header-status">
        {activeExperiment && (
          <>
            <span className="mono-label">TRIAL {Math.min(state.blockNumber + 1, 3)} / 3</span>
            <span className={`test-condition-badge condition-${condition.toLowerCase()}`}>
              TEST CONDITION {condition}
            </span>
          </>
        )}
        <span className={`save-state save-${saveStatus}`}>
          <i aria-hidden="true" />
          {statusText[saveStatus]}
        </span>
        {activeExperiment && (
          <button className="text-button" type="button" onClick={onStop}>
            実験を中止
          </button>
        )}
      </div>
    </header>
  );
}
